// DataDog ブラウザロガー
import '@/util/logger/BrowserLogger';

// グローバルオブジェクトのユーティリティ
// (いずれビルド対象ファイルが増えたらモジュール化したい)
import './global';

// AngularJS 初期化処理
import './initialize';
